// A KÖZPONTI (multi-app) admin-konzol app-választója — a MEGLÉVŐ `Select` komponenssel (nincs új design).
// `null`-t renderel, ha csak egy app van (a jelenlegi, egy-appos állapot) → az admin-oldalak változatlanok.
import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { type AdminApp } from '@/lib/use-admin-apps';

export function AppSelector({
  apps,
  value,
  onChange,
  show,
}: {
  apps: AdminApp[];
  value: string;
  onChange: (key: string) => void;
  show: boolean;
}): JSX.Element | null {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-8 w-44 text-sm" aria-label={t('common.appSelector')}>
        <SelectValue placeholder={t('common.appSelector')} />
      </SelectTrigger>
      <SelectContent>
        {apps.map((a) => (
          <SelectItem key={a.key} value={a.key}>
            {a.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
